export default "__VITE_ASSET__BHqFwrzN__"